"use client";
import { DEFAULT_SOCIETY_NAME } from "@/lib/site-settings";

import { useEffect } from "react";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => { console.error(error); }, [error]);
  return <html lang="fr"><body><main className="system-error-page"><div className="system-error-card"><p className="section-label">{DEFAULT_SOCIETY_NAME}</p><h1>Le site rencontre un problème.</h1><p>Le service n’a pas pu démarrer correctement. Réessaie dans quelques instants.</p><button className="button button-primary" onClick={reset}>Réessayer</button></div></main></body></html>;
}
